import React, {SyntheticEvent, useCallback} from 'react';
import './ImpactUrgency.less';
import Task, {ImpactType, UrgencyType} from '../../entities/task';
import * as TaskHelper from '../../TaskManagement/TaskHelper';

const CODE_LABELS: Record<string, string> = {H: 'High', M: 'Medium', L: 'Low'};

/**
 * Simple 3x3 grid for impact and urgency
 */
function ImpactUrgency(props: ImpactUrgencyProps) {
	const {task, mode, useNumbers} = props;
	const selected = TaskHelper.getGridNumber(task);

	const renderGrid = useCallback(() => {
		const onClick = (e: SyntheticEvent, iuNumber: number) => {
			e.preventDefault();
			e.stopPropagation();

			const {impact, urgency} = TaskHelper.getCodeFromGridNumber(iuNumber);
			props.onClick?.(impact, urgency);
		}

		const nums = [4, 2, 1, 7, 5, 3, 9, 8, 6];

		return <div className='impact-urgency impact-urgency__grid'>
			{nums.map(num => {
				const selClass = (num === selected) ? 'selected' : '';
				return <div key={num}
							className={`impact-urgency__grid-block ${selClass}`}
							onClick={e => onClick(e, num)}>
					{num}
				</div>
			})}
		</div>;
	}, [selected, props]);

	const renderCapsule = useCallback(() => {
		return <div className='impact-urgency impact-urgency__capsule'>
			{useNumbers && <div className={TaskHelper.getTaskStyle(task)}>{TaskHelper.getGridNumber(task)}</div>}
			{!useNumbers && <div className={`impact-urgency--i impact-urgency--${task.impact}`} title={`${CODE_LABELS[task.impact] || task.impact} Impact`}>{task.impact}</div>}
			{!useNumbers &&
				<div className={`impact-urgency--u impact-urgency--${task.urgency}`} title={`${CODE_LABELS[task.urgency] || task.urgency} Urgency`}>{task.urgency}</div>}
		</div>
	}, [useNumbers, task]);

	return mode === 'grid' ? renderGrid() : renderCapsule();
}

export type ImpactUrgencyProps = {
	/**
	 * The task to show
	 */
	task: Task,
	/**
	 * Display mode. 'grid' is a 3x3 grid (like TaskGrid), capsule is (impact|urgency).
	 */
	mode?: 'grid' | 'capsule',

	/**
	 * Click handler (read-only if none supplied).
	 * Function return {impact, urgency}.
	 */
	onClick?: (impact: ImpactType, urgency: UrgencyType) => void,

	/**
	 * Use numbers instead of IU
	 */
	useNumbers?: boolean,
};

export default ImpactUrgency;
